import { render, staticRenderFns } from "./AccountTransactionVersionCardContent.vue?vue&type=template&id=1d030a9f&"
import script from "./AccountTransactionVersionCardContent.vue?vue&type=script&lang=ts&"
export * from "./AccountTransactionVersionCardContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports